export default __webpack_public_path__ + "d204c2ec435d3206d5bd611de99212f4.svg";